import { FC, ReactElement } from 'react';

import { AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, rem } from '@bonusly/design-system';

interface Props {
	badgeCount?: number;
	children: ReactElement;
	icon: ReactElement;
	label: string;
}

export const TopLevelNavItem: FC<Props> = ({ badgeCount = 0, icon, children, label }) => {
	return (
		<AccordionItem id={`${label.toLowerCase().replace(/\s/g, '-')}`} as="li" role="menuitem" border="none" borderRadius="sm" mb={2} listStyleType="none">
			{({ isExpanded }) => (
				<>
					<AccordionButton
						borderRadius="sm"
						px={3}
						h={10}
						position="relative"
						_hover={{ bg: 'bg.subtle', borderRadius: 'sm' }}
						_expanded={{
							bg: 'bg.subtle',
							borderBottomRadius: 'none',
							_focusVisible: { borderBottomRadius: 'sm' },
						}}
					>
						<Box as="span" pr={2}>
							{icon}
						</Box>
						{badgeCount > 0 && (
							<Box
								data-testid="top-level-badge"
								bgColor="danger.bg"
								borderColor="bg.surface"
								borderRadius="full"
								borderWidth="1px"
								h={2}
								w={2}
								position="absolute"
								top={2}
								left={rem(29)}
							/>
						)}
						<Box as="span" flex="1" textAlign="left" verticalAlign="middle" color="text.default" fontSize={50} fontWeight="medium" fontFamily="ui">
							{label}
						</Box>
						<AccordionIcon
							h={6}
							w={6}
							{...(isExpanded && {
								borderRadius: 'full',
								bg: 'secondary.bgAlpha',
							})}
						/>
					</AccordionButton>
					<AccordionPanel pb={1} px={1} bg="bg.subtle" borderBottomRadius="sm">
						{children}
					</AccordionPanel>
				</>
			)}
		</AccordionItem>
	);
};
